import { FrameChrome } from "./FrameChrome";

interface ClusterFrameNodeData {
  label: string;
  subtitle?: string;
  kind: "worker" | "external" | "system";
  borderStyle: "solid" | "dashed";
  [key: string]: unknown;
}

// L2 sub-boundary chrome at L2/L3 (BACKGROUND WORKERS, EXTERNAL SERVICES),
// also used for L1 external clusters (e.g. MICROSOFT 365 STACK). Sits
// behind the contained nodes; never participates in focus/hover
// choreography (NON_FOCUSABLE_TYPES in GraphCanvas.tsx).
//
// Visual contract lives in FrameChrome. This component owns only the
// kind → token mapping.
//
// Spec: docs/superpowers/specs/2026-05-25-archviz-cluster-framing-design.md

const TOKENS_BY_KIND: Record<ClusterFrameNodeData["kind"], { fillVar: string; borderVar: string }> =
  {
    worker: {
      fillVar: "--cluster-worker-fill",
      borderVar: "--cluster-worker-border",
    },
    external: {
      fillVar: "--cluster-external-fill",
      borderVar: "--cluster-external-border",
    },
    system: {
      fillVar: "--cluster-system-fill",
      borderVar: "--cluster-system-border",
    },
  };

export function ClusterFrameNode({ data }: { data: ClusterFrameNodeData }) {
  const tokens = TOKENS_BY_KIND[data.kind];
  return (
    <FrameChrome
      label={data.label}
      subtitle={data.subtitle}
      fillVar={tokens.fillVar}
      borderVar={tokens.borderVar}
      borderStyle={data.borderStyle}
    />
  );
}
